import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var CharWidthRequest = /*#__PURE__*/function () {
  function CharWidthRequest(chr, type) {
    _classCallCheck(this, CharWidthRequest);

    this.chr = chr;
    this.type = type;
    this.width = 0;
  }

  _createClass(CharWidthRequest, [{
    key: "fulfill",
    value: function fulfill(width) {
      this.width = width;
    }
  }]);

  return CharWidthRequest;
}();

var DomCharWidthReader = /*#__PURE__*/function () {
  function DomCharWidthReader(bareFontInfo, requests) {
    _classCallCheck(this, DomCharWidthReader);

    this._bareFontInfo = bareFontInfo;
    this._requests = requests;
    this._container = null;
    this._testElements = null;
  }

  _createClass(DomCharWidthReader, [{
    key: "read",
    value: function read() {
      // Create a test container with all these test elements
      this._createDomElements(); // Add the container to the DOM


      document.body.appendChild(this._container); // Read character widths

      this._readFromDomElements(); // Remove the container from the DOM


      document.body.removeChild(this._container);
      this._container = null;
      this._testElements = null;
    }
  }, {
    key: "_createDomElements",
    value: function _createDomElements() {
      var container = document.createElement('div');
      container.style.position = 'absolute';
      container.style.top = '-50000px';
      container.style.width = '50000px';
      var regularDomNode = document.createElement('div');
      regularDomNode.style.fontFamily = this._bareFontInfo.getMassagedFontFamily();
      regularDomNode.style.fontWeight = this._bareFontInfo.fontWeight;
      regularDomNode.style.fontSize = this._bareFontInfo.fontSize + 'px';
      regularDomNode.style.fontFeatureSettings = this._bareFontInfo.fontFeatureSettings;
      regularDomNode.style.lineHeight = this._bareFontInfo.lineHeight + 'px';
      regularDomNode.style.letterSpacing = this._bareFontInfo.letterSpacing + 'px';
      container.appendChild(regularDomNode);
      var boldDomNode = document.createElement('div');
      boldDomNode.style.fontFamily = this._bareFontInfo.getMassagedFontFamily();
      boldDomNode.style.fontWeight = 'bold';
      boldDomNode.style.fontSize = this._bareFontInfo.fontSize + 'px';
      boldDomNode.style.fontFeatureSettings = this._bareFontInfo.fontFeatureSettings;
      boldDomNode.style.lineHeight = this._bareFontInfo.lineHeight + 'px';
      boldDomNode.style.letterSpacing = this._bareFontInfo.letterSpacing + 'px';
      container.appendChild(boldDomNode);
      var italicDomNode = document.createElement('div');
      italicDomNode.style.fontFamily = this._bareFontInfo.getMassagedFontFamily();
      italicDomNode.style.fontWeight = this._bareFontInfo.fontWeight;
      italicDomNode.style.fontSize = this._bareFontInfo.fontSize + 'px';
      italicDomNode.style.fontFeatureSettings = this._bareFontInfo.fontFeatureSettings;
      italicDomNode.style.lineHeight = this._bareFontInfo.lineHeight + 'px';
      italicDomNode.style.letterSpacing = this._bareFontInfo.letterSpacing + 'px';
      italicDomNode.style.fontStyle = 'italic';
      container.appendChild(italicDomNode);
      var testElements = [];

      var _iterator = _createForOfIteratorHelper(this._requests),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var request = _step.value;
          var parent = void 0;

          if (request.type === 0
          /* Regular */
          ) {
            parent = regularDomNode;
          }

          if (request.type === 2
          /* Bold */
          ) {
            parent = boldDomNode;
          }

          if (request.type === 1
          /* Italic */
          ) {
            parent = italicDomNode;
          }

          parent.appendChild(document.createElement('br'));
          var testElement = document.createElement('span');

          DomCharWidthReader._render(testElement, request);

          parent.appendChild(testElement);
          testElements.push(testElement);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._container = container;
      this._testElements = testElements;
    }
  }, {
    key: "_readFromDomElements",
    value: function _readFromDomElements() {
      for (var i = 0, len = this._requests.length; i < len; i++) {
        var request = this._requests[i];
        var testElement = this._testElements[i];
        request.fulfill(testElement.offsetWidth / 256);
      }
    }
  }], [{
    key: "_render",
    value: function _render(testElement, request) {
      if (request.chr === ' ') {
        var htmlString = "\xA0"; // Repeat character 256 (2^8) times

        for (var i = 0; i < 8; i++) {
          htmlString += htmlString;
        }

        testElement.innerText = htmlString;
      } else {
        var testString = request.chr; // Repeat character 256 (2^8) times

        for (var _i = 0; _i < 8; _i++) {
          testString += testString;
        }

        testElement.textContent = testString;
      }
    }
  }]);

  return DomCharWidthReader;
}();

export function readCharWidths(bareFontInfo, requests) {
  var reader = new DomCharWidthReader(bareFontInfo, requests);
  reader.read();
}